import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { List, Typography } from 'antd'

import { SubjectTag } from './styled'

// A list and not a table: three columns are unreadable at 390 px. The subject is the title,
// because that is what the reader has in front of them in their inbox.
const EmailList = props => {
  const { emails } = props

  return (
    <>
      <p>
        <FormattedMessage id={'help.emails.intro'} />
      </p>
      <p>
        <Typography.Text type={'secondary'}>
          <FormattedMessage id={'help.emails.language'} />
        </Typography.Text>
      </p>
      <List
        size={'small'}
        dataSource={emails}
        renderItem={email => (
          <List.Item>
            <List.Item.Meta
              title={
                <SubjectTag>
                  <FormattedMessage id={`help.emails.${email}.subject`} />
                </SubjectTag>
              }
              description={<FormattedMessage id={`help.emails.${email}.body`} />}
            />
          </List.Item>
        )}
      />
    </>
  )
}
EmailList.propTypes = {
  emails: PropTypes.array.isRequired
}
export default EmailList
